import React, { useEffect, useRef } from 'react'
import { ElfsightWidget } from 'react-elfsight-widget'
import { reportToSentry } from 'utils/reportToSentry'

type BaseElfWidgetProps = {
  widgetId: string
  widgetName: string
}

const BaseElfWidget = ({widgetId, widgetName}: BaseElfWidgetProps ) : JSX.Element => {
  const hasReportedError = useRef( false )

  useEffect( () => {
    if ( !ElfsightWidget || !widgetId ) {
      if ( !hasReportedError.current ) {
        reportToSentry(
          new Error( `${widgetName}: error loading Elfsight widget. Widget ID: ${widgetId}` )
        )
        hasReportedError.current = true
      }
    }
  }, [ ElfsightWidget, widgetId, widgetName ] )

  return (
    <ElfsightWidget widgetId={widgetId} modern />
  )
}

export default BaseElfWidget
